// extracted by mini-css-extract-plugin
module.exports = {"root":"activeDataRequests_root__1yFYb","description":"activeDataRequests_description__2PlyV","scrolling_tabs":"activeDataRequests_scrolling_tabs__3bbDL"};